<template>
  <div class="concatUs">
    <div class="intro">
      <div class="left">
        <img class="line" src="../../assets/index/line.png" alt="" />
        <div class="title">联系我们</div>
      </div>
    </div>

    <div
      class="top"
      :style="{
        'background-image': `url(${contact_tel_bg_image})`,
      }"
    >
      <div class="wrap">
        <div class="contWrap">
          <div class="iphone">
            <img src="../../assets/concat/iphone.png" alt="" />
          </div>
          <div>
            <div class="zx">{{ contact_tel_title }}</div>
            <div class="num">{{ contact_tel_value }}</div>
            <div class="desc">{{ contact_tel_desc }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="middle">
      <div class="flex">
        <div class="icon">
          <img src="../../assets/concat/wechat.png" alt="" />
        </div>
        <div class="right">
          <div class="title">{{ contact_wx_title }}</div>
          <div class="id">ID：{{ contact_wx_id }}</div>
          <div class="ewm">
            <img :src="`${contact_wx_image}`" alt="" />
          </div>
        </div>
      </div>
      <div class="flex douyinw">
        <div class="icon">
          <img src="../../assets/concat/douyin.png" alt="" />
        </div>
        <div class="right">
          <div class="title">{{ contact_dy_title }}</div>
          <div class="id">ID：{{ contact_dy_id }}</div>
          <div class="dym">
            <img :src="`${contact_dy_image}`" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="location">
      <div>
        <div class="title">{{ contact_store_title }}</div>
        <div class="flex">
          <div class="little">
            <img src="../../assets/concat/local.png" alt="" />
          </div>
          <div class="address">
            形象店地址
            <p v-html="contact_store_address"></p>
          </div>
        </div>
      </div>
      <div class="shop"><img :src="`${contact_store_image}`" alt="" /></div>
    </div>
    <div class="location">
      <div>
        <div class="title">{{ contact_factory_title }}</div>
        <div class="flex">
          <div class="little">
            <img src="../../assets/concat/local.png" alt="" />
          </div>
          <div class="address">
            厂区地址
            <p v-html="contact_factory_desc"></p>
          </div>
        </div>
      </div>
      <div class="shop">
        <img :src="`${contact_factory_image}`" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { concatUs } from "../../api/request";

export default {
  name: "ConcatUs",

  data() {
    return {
      contact_dy_id: "",
      contact_dy_image: "",
      contact_dy_title: "",
      contact_factory_desc: "",
      contact_factory_image: "",
      contact_factory_title: "",
      contact_store_address: "",
      contact_store_image: "",
      contact_tel_desc: "",
      contact_tel_title: "",
      contact_tel_value: "",
      contact_wx_id: "",
      contact_wx_image: "",
      contact_wx_title: "",
      contact_store_title: "",
      contact_tel_bg_image: null,
    };
  },
  mounted() {
    concatUs().then((res) => {
      if (res.data.code == 1) {
        // console.log(res.data.data);
        var obj = res.data.data;
        this.contact_dy_id = obj.contact_dy_id;
        this.contact_dy_image = obj.contact_dy_image;
        this.contact_dy_title = obj.contact_dy_title;
        this.contact_factory_desc = obj.contact_factory_desc;
        this.contact_factory_image = obj.contact_factory_image;
        this.contact_factory_title = obj.contact_factory_title;
        this.contact_store_address = obj.contact_store_address;
        this.contact_store_image = obj.contact_store_image;
        this.contact_store_title = obj.contact_store_title;
        this.contact_tel_desc = obj.contact_tel_desc;
        this.contact_tel_title = obj.contact_tel_title;
        this.contact_tel_value = obj.contact_tel_value;
        this.contact_wx_id = obj.contact_wx_id;
        this.contact_wx_image = obj.contact_wx_image;
        this.contact_wx_title = obj.contact_wx_title;
        this.contact_tel_bg_image = obj.contact_tel_bg_image;
      }
    });
  },
};
</script>

<style scoped lang="less">
.concatUs {
  padding-top: 60px;
  margin: 0 auto;
  font-family: 微软雅黑, MicrosoftYaHei;
  .intro {
    width: 1280px;
    margin: 0 auto 42px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .left {
      text-align: left;
    }
    .line {
      width: 90px;
      height: 8px;
    }
    .title {
      font-size: 42px;
      font-weight: bold;
      color: #004c31;
      margin-top: 38px;
    }
    .subTitle {
      margin-top: 24px;
      font-size: 24px;
      font-weight: 400;
      color: #004c31;
    }
  }
  .top {
    width: 100%;
    height: 461px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    .wrap {
      display: flex;
      align-items: flex-start;
      .contWrap {
        width: 1280px;
        margin: 130px auto 0;
        display: flex;
        align-content: flex-start;
        .iphone {
          width: 104px;
          height: 104px;
          img {
            width: 104px;
            height: 104px;
          }
        }
        .zx {
          font-size: 32px;
          color: #ffffff;
        }
        .num {
          margin-top: 27px;
          font-size: 42px;
          font-weight: bold;
          color: #ffffff;
        }
        .desc {
          margin-top: 83px;
          color: #fff;
          font-size: 20px;
        }
      }
    }
  }
  .middle {
    padding: 98px 0 100px;
    width: 1280px;
    margin: 0 auto;
    display: flex;
    align-content: center;
    border-bottom: 1px dotted #f5f5f5;
    .flex {
      display: flex;
      align-content: flex-start;
    }
    .douyinw {
      margin-left: 253px;
    }
    .title {
      margin-top: 14px;
      font-size: 20px;
      color: #6c7a77;
    }
    .id {
      margin-top: 24px;
      font-size: 32px;
      color: #004c31;
    }
    .right {
      text-align: left;
      margin-left: 27px;
    }
    .icon {
      width: 106px;
      height: 106px;
      img {
        width: 106px;
        height: 106px;
      }
    }
    .ewm {
      width: 130px;
      height: 130px;
      margin-top: 63px;
    }
    .dym {
      margin-top: 40px;
      width: 178px;
      height: 178px;
    }
  }
  .location {
    padding: 48px 0;
    margin: 0 auto;
    width: 1280px;
    display: flex;
    align-content: flex-start;
    justify-content: space-between;
    .flex {
      display: flex;
      align-items: flex-start;
    }
    .title {
      text-align: left;
      font-size: 32px;
      color: #004c31;
    }
    .little {
      width: 23px;
      height: 23px;
      img {
        width: 23px;
        height: 23px;
      }
    }
    .address {
      margin-left: 8px;
      text-align: left;
      font-size: 20px;
      color: #6c7a77;
    }
    .shop {
      width: 642px;
      height: 342px;
      img {
        width: 642px;
        height: 342px;
      }
    }
  }
}
@media screen and (max-width: 450px) {
  .concatUs {
    padding-top: 60 * 2px;
    margin: 0 auto;
    font-family: 微软雅黑, MicrosoftYaHei;
    .intro {
      width: 1280px;
      margin: 0 auto 42px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      .left {
        text-align: left;
      }
      .line {
        width: 90 * 2px;
        height: 8 * 2px;
      }
      .title {
        font-size: 42 * 2px;
        font-weight: bold;
        color: #004c31;
        margin-top: 38 * 2px;
      }
      .subTitle {
        margin-top: 24 * 2px;
        font-size: 24 * 2px;
        font-weight: 400;
        color: #004c31;
      }
    }
    .top {
      width: 100%;
      height: 461 * 1.2px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
      .wrap {
        display: flex;
        align-items: flex-start;
        .contWrap {
          width: 1280px;
          margin: 130px auto 0;
          display: flex;
          align-content: flex-start;
          .iphone {
            width: 104 * 2px;
            height: 104 * 2px;
            img {
              width: 104 * 2px;
              height: 104 * 2px;
            }
          }
          .zx {
            font-size: 32 * 2px;
            color: #ffffff;
          }
          .num {
            margin-top: 27 * 2px;
            font-size: 42 * 2px;
            font-weight: bold;
            color: #ffffff;
          }
          .desc {
            margin-top: 83 * 2px;
            color: #fff;
            font-size: 20 * 2px;
          }
        }
      }
    }
    .middle {
      padding: 98px 100px;
      width: auto;
      margin: 0 auto;
      display: flex;
      align-content: center;
      border-bottom: 1px dotted #f5f5f5;
      .flex {
        display: flex;
        align-content: flex-start;
      }
      .douyinw {
        margin-left: 253px;
      }
      .title {
        margin-top: 14px;
        font-size: 20 * 2px;
        color: #6c7a77;
      }
      .id {
        margin-top: 24 * 2px;
        font-size: 32 * 2px;
        color: #004c31;
      }
      .right {
        text-align: left;
        margin-left: 27 * 2px;
      }
      .icon {
        width: 106 * 2px;
        height: 106 * 2px;
        img {
          width: 106 * 2px;
          height: 106 * 2px;
        }
      }
      .ewm {
        width: 130 * 2px;
        height: 130 * 2px;
        margin-top: 63px;
        img {
          width: 130 * 2px;
          height: 130 * 2px;
        }
      }
      .dym {
        margin-top: 40px;
        width: 178 * 2px;
        height: 178 * 2px;
        img {
          width: 178 * 2px;
          height: 178 * 2px;
        }
      }
    }
    .location {
      padding: 48px 100px;
      margin: 0 auto;
      width: auto;
      display: flex;
      align-content: flex-start;
      justify-content: space-between;
      .flex {
        display: flex;
        align-items: flex-start;
      }
      .title {
        text-align: left;
        font-size: 32 * 2px;
        color: #004c31;
      }
      .little {
        width: 23 * 2px;
        height: 23 * 2px;
        img {
          width: 23 * 2px;
          height: 23 * 2px;
        }
      }
      .address {
        margin-left: 8px;
        text-align: left;
        font-size: 20 * 2px;
        color: #6c7a77;
      }
      .shop {
        width: 642px;
        height: 342px;
        img {
          width: 642px;
          height: 342px;
        }
      }
    }
  }
}
</style>
